/* @flow */
// $FlowIgnore
import _ from 'lodash';

let mustHaveAll = (userPrivileges, requiredPermissions) =>
  requiredPermissions.every(p => userPrivileges.includes(p));

export function projectPermissions(
  projectRoles: Object = {},
  projectId: string = ''
): [string] {
  return projectRoles[ projectId ] || [];
}

export function isPermitted(
  projectRoles: Object = {},
  permissions: [string] = [],
  projectId: string
): boolean {
  let privileges = projectPermissions(projectRoles, projectId);
  return mustHaveAll(privileges, permissions);
}

export function permittedProjects(
  projectRoles: Object = {},
  permissions: [string] = []
): [string] {
  return Object.keys(_.pick(projectRoles, roles => mustHaveAll(roles, permissions)));
}
